import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container mx-auto p-4 flex flex-col items-center justify-center min-h-[50vh] text-center">
      <div className="text-6xl mb-4">☄️</div>
      <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-3">
        404 — Page Not Found
      </h1>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        The page you are looking for doesn&apos;t exist or has been moved.
      </p>
      <Link
        to="/home"
        className="bg-teal-500 hover:bg-teal-600 text-white font-bold py-2 px-6 rounded transition-colors"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
